export const getPercentage = (votes: number, totalVotes: number): number => {
    const percentage = totalVotes > 0 ? (votes / totalVotes) * 100 : 0;
    return Math.round(percentage);
};
